<section id="experience" class="py-24 sm:py-32 bg-surface">
  <div class="container mx-auto px-6 lg:px-10">
    <!-- Section header -->
    <div class="flex items-center gap-4 mb-14" data-aos="fade-up" data-aos-delay="200">
      <span class="font-mono text-[10px] text-accent/40 tracking-widest select-none">///</span>
      <span class="text-accent font-mono text-sm">02</span>
      <h2 class="text-3xl sm:text-4xl font-display font-black text-text-strong">
        {{ "experience.title" | translate }}
      </h2>
      <span class="flex-1 h-px bg-subtle"></span>
    </div>

    <div class="relative border-l border-subtle pl-8 space-y-8">
      @for (experience of experiences; track $index; let i = $index) {
        <div class="relative" [attr.data-aos]="isMobile ? 'zoom-in' : 'fade-left'" data-aos-delay="200">
          <!-- Timeline dot -->
          <span class="absolute -left-2.75 top-7 h-3 w-3 rounded-full border-2 border-accent bg-surface"></span>

          <div class="bg-surface-100/60 border border-subtle rounded-xl p-6 hover:border-accent/20 transition-colors duration-300">
            <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-2 mb-3">
              <h3 class="text-xl sm:text-2xl font-display font-bold text-text-strong">
                {{ experience.company }}
              </h3>
              <p class="text-[10px] uppercase tracking-[0.2em] text-muted font-mono bg-surface-200/60 px-3 py-1 rounded">
                {{ experience.period }}
              </p>
            </div>
            <p class="font-mono text-sm text-accent mb-4">
              {{ experience.position }}
            </p>
            <ul class="text-muted-light text-sm leading-relaxed space-y-1.5">
              @for (responsibility of experience.responsibilities; track $index) {
                <li class="flex items-start gap-2">
                  <span class="text-accent/50 mt-1 text-xs">&#9656;</span>
                  <span>{{ responsibility }}</span>
                </li>
              }
            </ul>
            @if (experience.technologies && objectKeys(experience.technologies).length) {
              <div class="mt-5">
                <button
                  class="px-3 py-1.5 text-xs font-mono text-muted-light border border-subtle rounded hover:border-accent hover:text-accent transition-all duration-300"
                  (click)="toggleTechnologies(i)">
                  <i class="w-3 h-3 mr-1.5" [ngClass]="isTechnologyVisible(i) ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                  {{ isTechnologyVisible(i) ? ('experience.hideText' | translate) : ('experience.showText' | translate) }}
                </button>
                @if (isTechnologyVisible(i)) {
                  <div class="mt-4 space-y-5 animate-slideIn">
                    <h3 class="text-sm font-display font-bold text-muted-light">{{ 'experience.techSectionTitle' | translate }}</h3>
                    @for (category of objectKeys(experience.technologies); track $index) {
                      <div class="border-t border-subtle pt-3">
                        <h4 class="text-[10px] font-mono text-muted tracking-[0.2em] uppercase flex items-center gap-2">
                          <i [ngClass]="iconMap[category] || 'fas fa-tag'" class="text-accent w-4 h-4"></i>
                          {{ experience.technologies[category].title }}
                        </h4>
                        <div class="flex flex-wrap gap-1.5 mt-2">
                          @for (tech of experience.technologies[category].items; track $index) {
                            <span
                              class="px-2.5 py-0.5 text-xs font-mono rounded border border-subtle bg-surface-200/60 text-muted-light hover:border-accent/30 hover:text-accent transition-colors duration-200"
                              [attr.title]="tech">
                              {{ tech }}
                            </span>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</section>
